<div class="weekly-operational-hours">
    <div class="component-label">
        <label >{{configData.label}}</label>
    </div>
    <form id="weeklyOperationHoursForm" [formGroup]="intermediateForm" novalidate>
        <table class="largeScreen">
            <thead>
                <tr>
                    <th class="table-heading">Days in a Week</th>
                    <th class="table-heading"></th>
                    <th class="table-heading"><label class="table-heading-lable">From Time</label></th>
                    <th></th>
                    <th class="table-heading"><label class="table-heading-lable">To Time</label></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let day of weekdays"  formGroupName="{{day}}">
                    <td><label class="day">{{day}}</label></td>
                    <td> 
                        <div class="toggle-button-outer">
                            <label class="dhl-switch-v2">
                                <input type="checkbox" formControlName="isPresent" (change)="toggleEnable($event, day, 'isPresent')" />
                            <span class="dhl-slider-v2 dhl-round-v2"> </span>
                            </label>
                            <label class="toggle-label">{{ getControlByName(day, 'isPresent').value ? 'Open' : 'Closed'}}</label>
                          </div>
                          
                          
                        <!-- <input type="checkbox" formControlName="isPresent" (change)="toggleEnable($event, day, 'isPresent')" /> Open -->
                    </td>
                    <td>                        
                        <select formControlName="from" (change)="updateForm($event)">
                            <option value="{{hour}}" *ngFor="let hour of hours">{{hour}}</option>                            
                        </select>
                    </td>
                    <td><div class="Line-2"></div></td>
                    <td>
                        <select formControlName="to" (change)="updateForm($event)">
                            <option value="{{hour}}" *ngFor="let hour of hours">{{hour}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>   
        <table  class="smalldevice">
            <thead>
              <tr>
                  <th class="table-heading">Days in a Week</th>
                  <!-- <th class="table-heading"></th>
                  <th class="table-heading"><label class="table-heading-lable">From Time</label></th>
                  <th></th>
                  <th class="table-heading"><label class="table-heading-lable">To Time</label></th> -->
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let day of weekdays"  formGroupName="{{day}}">
                  <td class="day-td"><label class="day">{{day}}</label></td>
                  <td class="toggle-td"> 
                      <div class="toggle-button-outer">
                          <label class="dhl-switch-v2">
                              <input type="checkbox" formControlName="isPresent" (change)="toggleEnable($event, day, 'isPresent')" />
                          <span class="dhl-slider-v2 dhl-round-v2"> </span>
                          </label>
                          <label class="toggle-label">{{ getControlByName(day, 'isPresent').value ? 'Open' : 'Closed'}}</label>
                        </div>
                        
                        
                      <!-- <input type="checkbox" formControlName="isPresent" (change)="toggleEnable($event, day, 'isPresent')" /> Open -->
                  </td>
                  <td class="time-td">                        
                      <select formControlName="from" (change)="updateForm($event)">
                          <option value="{{hour}}" *ngFor="let hour of hours">{{hour}}</option>                            
                      </select>
                  </td>
                  <td><div class="Line-2"></div></td>
                  <td class="time-td">
                      <select formControlName="to" (change)="updateForm($event)">
                          <option value="{{hour}}" *ngFor="let hour of hours">{{hour}}</option>
                      </select>
                  </td>
              </tr>
          </tbody>
      </table>      
    </form>
</div>
